import { render, staticRenderFns } from "./select-user.vue?vue&type=template&id=64e8492b&"
import script from "./select-user.vue?vue&type=script&lang=js&"
export * from "./select-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports